module.exports = __webpack_public_path__ + "static/memory_img4M@2x-6d4f09aea6227b0474a3d948ddbaa4b1.png";